module.exports = __webpack_public_path__ + "img/l-03.2f51c7f0.png";